module.exports = "<p>\n  lost-my-pass works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/lost-my-pass/lost-my-pass.component.html
// module id = ../../../../../src/app/autentication/lost-my-pass/lost-my-pass.component.html
// module chunks = main